import { CountryEnumType } from '__generated__/graphql';

export default function countryCodeToReadable(code: CountryEnumType): {
  label: string;
  color: string;
} {
  switch (code) {
    case CountryEnumType.In:
      return {
        label: 'India',
        color: '#43A047',
      };
    case CountryEnumType.Us:
      return {
        label: 'United States',
        color: '#FB8C00',
      };
    case CountryEnumType.Sg:
      return {
        label: 'Singapore',
        color: '#FB8C00',
      };
    default:
      return {
        label: code,
        color: '#000',
      };
  }
}
